var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12 12)",
    id: "a17e4328-9889-43ea-9267-7b4cc28d738d"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -12,
    y: -12,
    rx: 0,
    ry: 0,
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)",
    id: "661383f4-23f6-4c3a-be1f-6da15dfcdc52"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21 0 0 0.21 12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(85,85,85)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-75.02, -106.77)",
    d: "M 129.49 114.51 C 129.121 116.961 128.187 119.293 126.762 121.322 C 125.337 123.351 123.461 125.021 121.28 126.2 C 120.676 126.535 120.043 126.816 119.39 127.04 C 120.22 138.04 102.74 142.04 93.32 139.42 L 96.82 151.66 L 87.82 151.98 L 72.07 129.43 C 66.76 130.93 60.49 131.65 56.44 125.15 C 56.0721 124.553 55.7382 123.935 55.44 123.3 C 54.4098 123.51 53.3614 123.617 52.31 123.62 C 49.31 123.62 44.31 122.72 41.77 120.96 C 39.7563 119.625 38.1588 117.75 37.16 115.55 C 31.75 116.29 27.16 115.02 24.16 111.88 C 20.36 107.97 19.28 101.51 21.26 94.58 C 23.87 85.33 31.81 74.91 47.59 71 C 48.9589 69.2982 50.5972 67.8322 52.44 66.66 C 62.35 60.31 78.44 59.76 90.65 65.79 C 95.3836 64.9082 100.27 65.376 104.75 67.14 C 113.53 70.43 119.91 77.31 121.11 84.3 C 123.487 85.5317 125.433 87.4568 126.69 89.82 C 129.32 94.76 129.69 99.71 127.92 103.71 C 129.587 107.049 130.138 110.835 129.49 114.51 Z M 123.01 109.31 C 121.612 110.048 120.056 110.434 118.475 110.434 C 116.894 110.434 115.338 110.048 113.94 109.31 L 114.67 104.46 C 117.75 104.76 120.26 103.8 121.57 101.83 C 123.04 99.64 122.81 96.39 120.95 92.9 C 118.87 88.99 114.38 88.37 111.89 88.34 L 111.73 88.34 C 105.49 88.34 99.13 91.89 96.56 96.52 L 92.82 94.73 C 93.5553 92.3449 94.8046 90.15 96.48 88.3 C 95.0376 87.0754 93.9474 85.4887 93.3217 83.703 C 92.696 81.9173 92.5574 79.9971 92.92 78.14 L 96.61 77.8 C 96.7789 79.302 97.4 80.7172 98.3911 81.8583 C 99.3822 82.9994 100.697 83.8125 102.16 84.19 C 105.238 82.8161 108.58 82.1335 111.95 82.19 C 112.43 82.19 112.89 82.24 113.36 82.27 C 110.969 78.0312 107.18 74.7545 102.64 73 C 91.56 68.7 84.09 75.37 82.38 77.67 C 78.26 83.19 80.9 88.41 82.91 91.8 L 79.61 94.8 C 76.736 92.314 74.8075 88.9127 74.15 85.17 C 69.92 86.44 64.24 86.17 61.06 80.74 L 64.06 78.68 C 67.43 81.2 72.78 80.98 75.32 77.87 C 75.9252 76.4949 76.6905 75.1959 77.6 74 C 79.044 72.093 80.7864 70.4316 82.76 69.08 C 74.47 66.82 62.76 67.19 55.68 71.73 C 53.7668 72.841 52.192 74.4517 51.1244 76.3895 C 50.0569 78.3274 49.5368 80.5192 49.62 82.73 C 49.62 86.3 52.42 91.94 56.19 92.82 L 54 97.07 C 51.5946 96.5129 49.4109 95.2487 47.73 93.44 L 44.48 97.58 L 41.23 96 L 44.41 87.68 C 43.8904 86.064 43.624 84.3774 43.62 82.68 C 43.628 81.3361 43.7687 79.9963 44.04 78.68 C 34.04 82.81 29.1 89.68 27.29 95.96 C 25.9 100.79 26.44 105.15 28.72 107.49 C 30.53 109.35 33.3 109.79 35.91 109.62 L 42.91 104.17 L 45.21 106.11 L 43.13 112.93 C 44.22 116.4 47.79 118.19 54.3 116.93 C 54.6375 114.169 55.7272 111.554 57.45 109.37 C 58.7133 107.552 60.3846 106.056 62.33 105 L 65.75 95.79 L 69.17 95.64 L 68.8 103.19 C 74.55 102.6 80.98 103.77 86.97 102.87 L 88.07 106.87 C 79.29 110.93 70.3 104.31 62.15 113.04 C 59.22 116.18 60.34 118.91 62.15 121.66 C 64.76 125.59 69.66 123.23 74.67 121.66 C 82.26 119.34 87.77 117.66 98.16 118.51 C 95.68 113.8 95.92 108.11 99.24 101.85 L 104.13 103.78 C 100.7 111.69 103.91 116.27 106.13 118.29 C 109.56 121.41 114.72 122.35 118.13 120.47 C 119.436 119.749 120.559 118.737 121.412 117.513 C 122.265 116.289 122.825 114.885 123.05 113.41 C 123.275 112.051 123.258 110.663 123 109.31 L 123.01 109.31 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.8d5977bb0502efb223a5ad2fdde58010.svg";
export { ForwardRef as ReactComponent };